//
//
//
//
//
//
//
//
//

export default {
  props: {
    to: {
      type: [String, Object],
      default: '/'
    }
  }
}
